import React from "react";
import { Routes, Route, Navigate } from "react-router";
import { LoginPage } from "./pages/LoginPage";
import { SorryPage } from "./pages/SorryPage";
import { ChangePasswordPage } from "./pages/ChangePasswordPage";
import { SecurityPage } from "./pages/SecurityPage";
import { Amplify } from "aws-amplify";
import { ENV } from "./config/env";

// 認証設定
Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId: ENV.COGNITO_USERPOOL_ID,
      userPoolClientId: ENV.CLIENT_ID,
    },
  },
});

/**
 * アプリ全体のエラーバウンダリ
 * 未ハンドルのレンダリングエラーをキャッチし、白画面を防止する
 */
class ErrorBoundary extends React.Component<
  { children: React.ReactNode },
  { hasError: boolean }
> {
  constructor(props: { children: React.ReactNode }) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(): { hasError: boolean } {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo): void {
    console.error("ErrorBoundary caught an error:", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen bg-white flex flex-col items-center justify-center px-4">
          <div className="w-full max-w-md text-center">
            <h2 className="text-2xl font-bold text-neutral-900 mb-4">
              予期しないエラーが発生しました
            </h2>
            <p className="text-neutral-600 mb-8">
              お手数ですが、ページを再読み込みしてください。
            </p>
            <button
              onClick={() => window.location.reload()}
              className="bg-primary hover:bg-primary/90 text-white py-3 px-8 rounded-2xl text-lg font-bold transition-colors"
            >
              再読み込み
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

function App() {
  return (
    <ErrorBoundary>
      <Routes>
        <Route path="/" element={<LoginPage />} />
        <Route path="/sorry" element={<SorryPage />} />
        <Route path="/change-password" element={<ChangePasswordPage />} />
        <Route path="/change-password/submitted" element={<ChangePasswordPage />} />
        <Route path="/security" element={<SecurityPage />} />
        {/* PRODUCT_DEV-421 alias ログインモード: `/:tenantId` でテナント固定エイリアスログイン */}
        <Route path="/:tenantId" element={<LoginPage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </ErrorBoundary>
  );
}

export default App;
